import { RequestStatus as Status } from "constants/RequestStatus";
import reducers from "./reducers";
import { createSlice } from "@reduxjs/toolkit";
import { ProfileState } from "types/Profile";

const initialState: ProfileState = {
  taxonomyOptionsByRole: [],
  taxonomyOptionsByRoleRequestStatus: Status.Loading,
  profileRequestStatus: Status.Loading,
  profileUpdateStatus: Status.Loading,
  profileFilterRole: {
    name: "",
    permission: [],
    description: "",
  },
};

export const profileSlice = createSlice({
  name: "profile",
  initialState,
  reducers,
});

export const {
  setTaxonomyOptionsByRole,
  setProfileUpdateStatus,
  setProfileRequestStatus,
  setTaxonomyOptionsByRoleRequestStatus,
  setProfileFilterRole,
} = profileSlice.actions;

export default profileSlice.reducer;
